(function () {
  function getLeadMeta(form, widget) {
    widget = widget || (form && form.closest("[data-lm-lead-widget]"));
    return {
      lm_lead_location:
        (form && form.getAttribute("data-lm-lead-location")) ||
        (widget && widget.getAttribute("data-lm-lead-location")) ||
        "",
      lm_lead_tag:
        (form && form.getAttribute("data-lm-lead-tag")) ||
        (widget && widget.getAttribute("data-lm-lead-tag")) ||
        "",
      lm_lead_page:
        (form && form.getAttribute("data-lm-lead-page")) ||
        (widget && widget.getAttribute("data-lm-lead-page")) ||
        "",
      lm_lead_form_id: form && form.id ? form.id : ""
    };
  }

  function track(action, form, widget, extra) {
    var detail = Object.assign(getLeadMeta(form, widget), extra || {});
    var dataLayerEvent = "lm_lead_" + action;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: dataLayerEvent }, detail));
    } catch (error) {}

    try {
      document.dispatchEvent(
        new CustomEvent("lm:lead:" + action, {
          detail: detail
        })
      );
    } catch (error) {}
  }

  window.LmLeadTrack = {
    track: track,
    getLeadMeta: getLeadMeta
  };
})();
